import { useCallback } from "react";
import { useDispatch, useSelector } from 'react-redux'
import { sendFeErrorMessage, setFeErrorLog } from "../actions/fe-error-notification-actions";
import { useToast } from "@chakra-ui/react";
import { getThisUserIdToken, triggerLaunchdeckToast } from "../helpers/global-helpers";

function useFeNotificationSender() {

  const dispatch = useDispatch();
  const toast = useToast();

  const currentErrorLog = useSelector(state => state.feErrorLog.results);

  const sendFeErrorNotification = useCallback(({errorCode, errorMessage, errorReportMetadata}) => {
    toast(
      triggerLaunchdeckToast({
        useCase: "show-error-state",
        bannerText: `Encountered unexpected error :: ${errorCode}`,
        label: "We're sorry about this - we've created a log and will resolve it as soon as we can. Please try again later.",
        isMobileView: false
      })
    )
    
    const newErrorLogged = !Array.isArray(currentErrorLog) || !currentErrorLog?.includes(errorCode);

    if (!!newErrorLogged) {
      dispatch(sendFeErrorMessage({
        userIdToken: getThisUserIdToken() || "",
        errorCode, 
        errorMessage, 
        errorReportMetadata
      }))

      dispatch(setFeErrorLog([...(currentErrorLog || []), errorCode]))   
    }
  }, [currentErrorLog, dispatch]);


  return { sendFeErrorNotification };
}


export default useFeNotificationSender